<script>
    import CompanyChooser from "../CompanyChooser.svelte";
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import {
        getNullPerson,
        getNullPersonCompany,
        I_COMPANY,
        I_PERSON,
        personAsObject,
        personCompanyAsObject,
        PERSON_LABELS
    } from "../../../../../../lib/datatypes";
    import {addPerson, selectPerson} from "../../stores/misc";
    import {tick} from "svelte";
    import {companies} from "../../stores/companies";
    import PeopleChooser from "../PeopleChooser.svelte";

    const getEmptyPerson = () => {
        let result = getNullPerson();
        result = personAsObject(result);
        result.positions = [personCompanyAsObject(getNullPersonCompany())];
        return result;
    };
    let add_person = getEmptyPerson();

    let position_being_edited = null;
    const onEditCompanyClick = index => {
        position_being_edited = index;
    };
    const onCompanyClick = company_id => {
        if(position_being_edited !== null) {
            add_person.positions[position_being_edited].id_company = company_id;
            add_person.positions[position_being_edited].company_name = $companies.lookup[company_id][I_COMPANY.NAME];
            position_being_edited = null;
        }
        else {
            console.warn(`no position being edited, why was this company clicked?`);
        }
    };

    const doAddPerson = async () => {
        let result = await addPerson(add_person);
        add_person = getEmptyPerson();
        await tick(); // ..have to wait for reactive structures to update

        selectPerson(result[I_PERSON.ID]);
        navigateTo(PAGE_ID.VIEW_PERSON);
    };

    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id);
        }
        else {
            navigateTo(PAGE_ID.PEOPLE);
        }
        add_person = getEmptyPerson();
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.ADD_PERSON}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
        </div>

    </div>

    <div class="px-4 sm:px-6 lg:px-8">

        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Add Person</h2>

        <div class="my-4 border-l-4 border-yellow-400 bg-yellow-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <p class="mb-4 text-sm text-yellow-700">
                        Use the searchbox below to check to see if the person you're adding is already in the database!
                    </p>
                </div>
            </div>
            <div>
                <PeopleChooser
                        type="box"
                        current_search_str=""
                        minimise_box_without_search={true}
                        allow_adding_people={false}></PeopleChooser>
            </div>
        </div>

        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">
            <div class="sm:col-span-3">
                <label for="first-name" class="block text-sm font-medium text-gray-900">First name</label>
                <input bind:value="{add_person.first_name}" type="text" name="first-name" id="first-name" autocomplete="given-name" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>

            <div class="sm:col-span-3">
                <label for="last-name" class="block text-sm font-medium text-gray-900">Last name</label>
                <input bind:value="{add_person.last_name}" type="text" name="last-name" id="last-name" autocomplete="family-name" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>

            {#each add_person.positions as position, i}
            <div class="sm:col-span-3">
                <label for="job-title" class="block text-sm font-medium text-gray-900">Position</label>
                <input bind:value="{position.position}" type="text" name="job-title" id="job-title" autocomplete="organization-title" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>

            <div class="sm:col-span-3">
                <label for="company" class="block text-sm font-medium text-gray-900">Company</label>
                {#if i === position_being_edited}
                    <CompanyChooser
                            type="box"
                            current_search_str=''
                            on:companyClicked={(e) => onCompanyClick(e.detail.id)}
                            on:cancelClicked={() => position_being_edited = null}></CompanyChooser>
                {:else}
                <input on:focus={() => onEditCompanyClick(i)} value="{position.company_name === undefined ? '' : position.company_name}" type="text" name="company" id="company" autocomplete="organization" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                {/if}
            </div>
            {/each}

        </div>

        <div class="flex justify-end pt-8">
            <button on:click={onBackClick}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >Cancel</button>
            <button on:click={doAddPerson}
                    type="submit"
                    class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >Save</button>
        </div>

    </div>

</div>


<style></style>